import { ColumnConfig } from '@/components/ui/data-table/config';

// TICKETS
// First 3 visible columns auto-collapse into summary on mobile:
//   Row 1: title (full width)
//   Row 2: users | labels
// prettier-ignore
export const ticketsTableConfig: ColumnConfig[] = [
  { col: 'title',            visible: true,  pos: 0,  sort: [2, true ]},
  { col: 'users',            visible: true,  pos: 1,  sort: null      },
  { col: 'labels',           visible: true,  pos: 2,  sort: null      },
  { col: 'werk_id',          visible: true,  pos: 3,  sort: null      },
  { col: 'due',              visible: true,  pos: 4,  sort: null      },
  { col: 'number',           visible: false, pos: 5,  sort: [1, true ]},
  { col: 'status',           visible: false, pos: 6,  sort: [0, true ]},
  { col: 'assignee_user_id', visible: false, pos: 7,  sort: null      },
  { col: 'executor_user_id', visible: false, pos: 8,  sort: null      },
  { col: 'project',          visible: false, pos: 9,  sort: null      },
  { col: 'customer',         visible: false, pos: 10, sort: null      },
];

// Cross-project ticket view: project column visible at index 1.
// Built by sorting on pos, splicing project into index 1, then renumbering
// — robust against future reorderings of ticketsTableConfig.
export const ticketsCrossProjectTableConfig: ColumnConfig[] = (() => {
  const others = ticketsTableConfig
    .filter((c) => c.col !== 'project')
    .sort((a, b) => a.pos - b.pos);
  const project = ticketsTableConfig.find((c) => c.col === 'project');
  if (!project) return ticketsTableConfig;
  const ordered = [
    others[0],
    { ...project, visible: true },
    ...others.slice(1),
  ];
  return ordered.map((c, i) => ({ ...c, pos: i }));
})();

// PROJECTS
// prettier-ignore
export const projectsTableConfig: ColumnConfig[] = [
  { col: 'projectname',      visible: true,  pos: 0, sort: [2, false]},
  { col: 'klant_naam',       visible: true,  pos: 1, sort: [0, true ]},
  { col: 'id',               visible: true,  pos: 2, sort: [1, true ]},
  { col: 'recnum',           visible: false, pos: 3, sort: null      },
  { col: 'users',            visible: false, pos: 4, sort: null      },
  { col: 'following',        visible: false, pos: 5, sort: null      },
];

// LABELS
// prettier-ignore
export const labelsTableConfig: ColumnConfig[] = [
  { col: 'name',             visible: true,  pos: 1, sort: [1, true ]},
  { col: 'description',      visible: true,  pos: 2, sort: null      },
  { col: 'tickets',          visible: false, pos: 3, sort: null      },
  { col: 'lists',            visible: false, pos: 4, sort: null      },
  { col: 'deleted',          visible: false, pos: 5, sort: null      },
  { col: 'created',          visible: false, pos: 6, sort: null      },
  { col: 'modified',         visible: false, pos: 7, sort: null      },
];

// WORKS
// prettier-ignore
export const worksTableConfig: ColumnConfig[] = [
  { col: 'id',               visible: true,  pos: 0, sort: [1, true ]},
  { col: 'oms',              visible: true,  pos: 1, sort: [0, true ]},
  { col: 'afd',              visible: true,  pos: 2, sort: [2, true ]},
  { col: 'klant',            visible: false, pos: 3, sort: null      },
  { col: 'klant_naam',       visible: false, pos: 4, sort: null      },
  { col: 'recnum',           visible: false, pos: 5, sort: null      },
];

// WORKORDERS
// prettier-ignore
export const workordersTableConfig: ColumnConfig[] = [
  { col: 'summary',          visible: true,  pos: 0, sort: null      },
  { col: 'execution_date',   visible: true,  pos: 1, sort: [0, true ]},
  { col: 'werk_id',          visible: true,  pos: 2, sort: null      },
  { col: 'assigned_user_id', visible: true,  pos: 3, sort: null      },
  { col: 'creator_name',     visible: true,  pos: 4, sort: null      },
  { col: 'id',               visible: false, pos: 5, sort: null      },
  { col: 'progress',         visible: false, pos: 6, sort: null      },
  { col: 'customer_name',    visible: false, pos: 7, sort: null      },
  { col: 'location_address', visible: false, pos: 8, sort: null      },
  { col: 'department',       visible: false, pos: 9, sort: null      },
  { col: 'completed',        visible: false, pos: 10, sort: null     },
  { col: 'signed',           visible: false, pos: 11, sort: null     },
];

// CHECKLISTS
// prettier-ignore
export const checklistsTableConfig: ColumnConfig[] = [
  { col: 'name',             visible: true,  pos: 0, sort: [0, true ]},
  { col: 'status',           visible: true,  pos: 1, sort: null      },
  { col: 'werk_id',          visible: true,  pos: 2, sort: null      },
  { col: 'associated_users', visible: true,  pos: 3, sort: null      },
  { col: 'start_date',       visible: false, pos: 4, sort: null      },
  { col: 'end_date',         visible: false, pos: 5, sort: null      },
  { col: 'created',          visible: false, pos: 6, sort: [1, true ]},
  { col: 'modified',         visible: false, pos: 7, sort: null      },
];

// TEMPLATES
// prettier-ignore
export const templatesTableConfig: ColumnConfig[] = [
  { col: 'name',             visible: true,  pos: 0, sort: [0, true ]},
  { col: 'tags',             visible: true,  pos: 1, sort: null      },
  { col: 'feedback',         visible: true,  pos: 2, sort: null      },
  { col: 'created',          visible: true,  pos: 3, sort: [1, true ]},
  { col: 'modified',         visible: true,  pos: 4, sort: null      },
];

// ACCOUNTS
// prettier-ignore
export const accountsTableConfig: ColumnConfig[] = [
  { col: 'loginname',             visible: true,  pos: 0,  sort: [2, true] },
  { col: 'name',                  visible: true,  pos: 1,  sort: [1, true] },
  { col: 'password_strength',     visible: true,  pos: 2,  sort: null      },
  { col: 'internal',              visible: true,  pos: 3,  sort: null      },
  { col: 'activated',             visible: true,  pos: 4,  sort: null      },
  { col: 'email',                 visible: true,  pos: 5,  sort: null      },
  { col: 'department',            visible: false, pos: 6,  sort: null      },
  { col: 'last_successful_login', visible: false, pos: 7,  sort: [0, true] },
  { col: 'auth_attempts',         visible: false, pos: 8,  sort: null      },
  { col: 'recnum',                visible: false, pos: 9,  sort: null      },
  { col: 'relat',                 visible: false, pos: 10, sort: null      },
  { col: 'contact',               visible: false, pos: 11, sort: null      },
  { col: 'expires_on',             visible: true,  pos: 12, sort: null      },
  { col: 'note',                  visible: false, pos: 13, sort: null      },
];

// DOCS (tree mode; rows are either groups or files via discriminated union)
// First 3 visible columns auto-collapse into mobile summary:
//   Row 1: name (full width, contains chevron + folder/file icon)
//   Row 2: revision | size
// prettier-ignore
export const docsTableConfig: ColumnConfig[] = [
  { col: 'name',             visible: true,  pos: 0, sort: null      },
  { col: 'revision',         visible: true,  pos: 1, sort: null      },
  { col: 'size',             visible: true,  pos: 2, sort: null      },
  { col: 'date',             visible: true,  pos: 3, sort: null      },
  { col: 'extension',        visible: false, pos: 4, sort: null      },
  { col: 'checksum',         visible: false, pos: 5, sort: null      },
];

// CACHE ENTRIES (Beheer → Cache)
// prettier-ignore
export const cacheEntriesTableConfig: ColumnConfig[] = [
  { col: 'resource',    visible: true,  pos: 0, sort: null       },
  { col: 'query',       visible: true,  pos: 1, sort: null       },
  { col: 'size',        visible: true,  pos: 2, sort: null       },
  { col: 'last_hit',    visible: true,  pos: 3, sort: [0, false] },
  { col: 'created',     visible: true,  pos: 4, sort: null       },
  { col: 'principal',   visible: false, pos: 5, sort: null       },
  { col: 'stored_size', visible: false, pos: 6, sort: null       },
  { col: 'status',      visible: false, pos: 7, sort: null       },
  { col: 'key',         visible: false, pos: 8, sort: null       },
];
